import {FC} from "react";
import {ITypeRadar} from "../../../types";
import {TitleCard} from "../styles";
import {
  IClustersMolecule,
  IProductsItem,
  ITehnologiesDataFromServer,
} from "../../../pages/Dashboard/Dashboard.type";
import {ChartView} from "../../../types/chartView";
import {SideBarContentMapTehnologie} from "./SideBarContentMapTehnologie";
import {SidebarTab} from "../../Sidebar";
import OpenLinkIcon from "../../../assets/icons/link-out-bold.svg";

interface IProps {
  idMoleculeActive: number;
  data: IProductsItem | null;
  typeRadar: ITypeRadar;
  activeTab: string;
  dataTechnology?: ITehnologiesDataFromServer | undefined;
  dataCurrentMolecula: IClustersMolecule | undefined;
  colorTitle?: string;
  technologieId?: number | string | null;
  chartView?: ChartView;
  setChartView?: (value: ChartView) => void;
}

export const SideBarContentMoleculeTwo: FC<IProps> = ({
  idMoleculeActive,
  data,
  typeRadar,
  activeTab,
  dataTechnology,
  colorTitle,
  technologieId,
  chartView,
  setChartView,
}) => {
  return (
    <>
      {activeTab === SidebarTab.CPU ? (
        <SideBarContentMapTehnologie
          dataTehnology={dataTechnology}
          typeRadar={typeRadar}
          colorTitle={colorTitle}
          technologieId={technologieId}
          idMoleculeActive={idMoleculeActive}
          setChartView={setChartView}
          chartView={chartView}
        />
      ) : (
        <div>
          <div style={{fontSize: "15px", color: "#858E97"}}>
            {data?.companyName}
          </div>
          <TitleCard color="#00F0FF" style={{marginTop: "10px"}}>
            {data?.productName}
          </TitleCard>
          <br />
          <div
            style={{
              fontSize: "15px",
              color: "#66C6FA",
              textTransform: "uppercase",
              fontWeight: "500",
            }}
          >
            Кейс реализации продукта
          </div>
          <div style={{fontSize: "14px", color: "#fff", marginTop: "10px"}}>
            {data?.citation[0].children[0].text}
          </div>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <a
              href={data?.citationUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#66C6FA",
                fontSize: "15px",
                textDecoration: "none",
                fontWeight: "500",
              }}
            >
              Ссылка на кейс
            </a>
            <img
              src={OpenLinkIcon}
              alt="Open link"
              style={{fontWeight: "bold"}}
            />
          </div>
        </div>
      )}
    </>
  );
};
